import React from 'react';
import { useTranslation } from 'react-i18next';
import { Gift, Clock } from 'lucide-react';

const TrialBadge = ({ trialEndDate, className = "" }) => {
  const { t } = useTranslation();
  if (!trialEndDate) return null;

  const calculateDaysRemaining = () => {
    try {
      const endDate = new Date(trialEndDate);
      const now = new Date();
      const diffTime = endDate - now;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return Math.max(0, diffDays);
    } catch {
      return 0;
    }
  };

  const daysRemaining = calculateDaysRemaining();
  if (daysRemaining <= 0) return null;

  return (
    <div
      data-testid="trial-badge"
      className={`inline-flex items-center gap-2 bg-gradient-to-r from-green-500 to-emerald-500 text-white px-4 py-2 rounded-full shadow-lg ${className}`}
    >
      <Gift size={18} className="animate-pulse" />
      <div className="flex items-center gap-2">
        <span className="font-bold text-sm">{t('trial.threeMonthsFree')}</span>
        <span className="text-xs opacity-90">•</span>
        <div className="flex items-center gap-1">
          <Clock size={14} />
          <span className="text-xs font-medium">{t('trial.daysRemaining', { days: daysRemaining })}</span>
        </div>
      </div>
    </div>
  );
};

export default TrialBadge;
